<h1 class="sr-only"><span>PUNTOS DE VENTA SORTEO ANÁHUAC MAGNO 2026</span></h1>
<section class="punto-venta  banner-padding">
  <div class="container" data-aos="fade-up" data-aos-duration="1500" data-aos-easing="ease-in-out">
    <div class="row sub-headers-inside">


      <div class="col-12 text-center my-auto">
        <div class="overlap-signature header-inside">
          <span class="letter"> <span class="signature-text">Puntos </span></span>
          <h2 class="main-text">de venta</h2>
        </div>
        <p>
          Puebla - Xalapa - Tlaxcala - Guadalajara - Monterrey - Mérida - Cd. Victoria
        </p>
      </div>



    </div>
  </div>
</section>



<!-- puntosdeventa.component.html -->
<section class="cards">
  <div class="container">
    <div class="row justify-content-center">
      <ng-container *ngFor="let ciudad of lugaresPorCiudad">
        <div class="col-12">
          <h2 class="title-cards text-center mt-5 pt-5">{{ ciudad.titulo }}</h2>
        </div>

        <div class="col-lg-4 col-md-6 mb-4" *ngFor="let lugar of ciudad.lugares">
          <a [href]="lugar.urlmaps" target="_blank" class="card-link-custom">
            <div class="card card-custom">
              <img *ngIf="lugar.img" [src]="lugar.img" alt="{{ lugar.titulo_lugar }}" class="img-fluid card-img-top" />
              <button *ngIf="lugar.img" class="btn-icon" [style.backgroundColor]="ciudad.color">
                <i class="fa fa-caret-down"></i>
              </button>
              <div class="card-body">
                <h5 class="card-title" [style.color]="ciudad.color">{{ lugar.titulo_lugar }}</h5>
                <p *ngIf="lugar.contacto" class="card-contact">{{ lugar.contacto }}</p>
                <div class="card-text card-address" [innerHTML]="formatearDireccion(lugar.direccion)"></div>
                <p *ngIf="lugar.telefono" class="card-phone"><i class="fa fa-phone"></i> Tel. {{ lugar.telefono }}</p>
                <span class="btn-link-finder" [style.color]="ciudad.color">
                  <i class="fa fa-play"></i> Encuéntrame
                </span>
              </div>
            </div>
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</section>